import {emptyValue} from "./global";

export default function getClearingStatus(status, time_diff){
    if(time_diff === emptyValue && status !== 'closed') return 'overdue'
    return status;
}

